import { captureException } from '@sentry/react'
import { type UseQueryOptions, useQuery } from '@tanstack/react-query'
import {
	HttpGetNeedManualRetouchingSpacesResponse,
	type HttpGetPhotosetSpacesOptions,
	httpGetNeedManualRetouchingSpaces
} from '@/features/photoset/http/photoset.http'
import { parseAxiosPromise } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useGetNeedManualRetouchingSpaces = (
	promiseArgs: HttpGetPhotosetSpacesOptions,
	options?: Omit<
		UseQueryOptions<HttpGetNeedManualRetouchingSpacesResponse>,
		'queryFn' | 'queryKey'
	>
) => {
	return useQuery({
		...options,
		queryKey: [QUERY_KEYS.MANUAL_RETOUCHING_SPACES, promiseArgs],
		queryFn: () =>
			parseAxiosPromise({
				axiosPromise: httpGetNeedManualRetouchingSpaces(promiseArgs),
				responseShape: HttpGetNeedManualRetouchingSpacesResponse,
				onZodError: captureException
			})
	})
}
